import handleAppError from './handleAppError';


function setLocalStorage(name, value){
  localStorage.setItem(name, value);
}

function getLocalStorage(key){
  return localStorage.getItem(key);
}
export { handleAppError, setLocalStorage, getLocalStorage };
